import { ALTERAR_REGISTROS_POR_PAGINA_CENTRO_CUSTO } from '../../actions/types'

const initialState = 10

export default function (state = initialState, action) {
  switch (action.type) {
    case ALTERAR_REGISTROS_POR_PAGINA_CENTRO_CUSTO: {
      return action.payload
    }

    default:
      return state
  }
}
